import { Flex, Text } from '@mantine/core'
import { useEffect } from 'react'

import { type CoreBookingProduct } from '@flecto/types'
import { AvatarProduct } from '@flecto/ui'

import { useBookingItemAvailabilityCalculator } from '../../hooks/useBookingItemAvailabilityCalculator'
import { TooltipBookingProductOverbooking } from '../TooltipBookingProductOverbooking/TooltipBookingProductOverbooking'
import { TooltipBookingProductUnavailable } from '../TooltipBookingProductUnavailable/TooltipBookingProductUnavailable'

export type CellNameProps = {
  bookingProduct?: CoreBookingProduct
}

export function CellName({ bookingProduct }: CellNameProps) {
  const { isOverbooked, isUnavailable, setOriginalQuantity } =
    useBookingItemAvailabilityCalculator({
      bookingId: bookingProduct?.booking?.internal_id,
      itemId: bookingProduct?.product?.id,
      quantityStart: bookingProduct?.quantity,
    })

  useEffect(() => {
    // This is necessary to force recalcultate values on calculator
    setOriginalQuantity(bookingProduct?.quantity ?? 0)
  }, [bookingProduct])

  return (
    <Flex align='center' gap='sm'>
      <AvatarProduct product={bookingProduct?.product} />
      <Flex direction='column' style={{ overflow: 'hidden' }}>
        <Text fw={500} lh={1} truncate>
          {bookingProduct?.product?.title}
        </Text>
        {isOverbooked && <TooltipBookingProductOverbooking />}
        {isUnavailable && <TooltipBookingProductUnavailable />}
      </Flex>
    </Flex>
  )
}
